document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href^="#"]');
  if (!link || link.getAttribute('href') === '#') return;

  const hash = link.getAttribute('href').slice(1);
  if (document.getElementById(hash)) return;

  const target = document.querySelector(`[id$="__${hash}"]`);
  if (!target) return;

  event.preventDefault();

  const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
  const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight;

  window.scrollTo({ top: targetPosition, behavior: 'smooth' });
  history.pushState(null, '', `#${hash}`);
});
